import { useNavigate } from 'react-router-dom';
import { setNavigate } from '@tickitacka/shared';

/**
 * 라우터 설정 컴포넌트
 * 네비게이션 함수를 전역에서 사용할 수 있도록 설정합니다.
 * BrowserRouter 내부에서만 사용해야 합니다.
 */
export const RouterSetup = () => {
    const navigate = useNavigate();
    
    // 전역 네비게이션 설정
    setNavigate(navigate);
    
    return null;
}; 